import React, { FC } from 'react';
import { createStyles, WithStyles, withStyles } from '@material-ui/core/styles';

import { ReactComponent as ReplyArrow } from '../../assets/svgs/replyarrow.svg';

const styles = () =>
  createStyles({
    unreadIndicator: {
      backgroundColor: '#f50057',
    },
  });

export enum ChatMemberIndicatorTestID {
  UnreadMessageIndicator = 'ChatMemberIndicatorTestID.NewMessageIndicator',
  NeedsReplyIndicator = 'ChatMemberIndicatorTestID.NeedsReplyIndicator',
  EmptyIndicator = 'ChatMemberIndicatorTestID.EmptyIndicator',
}

type Props = WithStyles & {
  hasUnreadMessages: boolean;
  lastMessageIsFrom: 'provider' | 'client' | undefined;
};

const ChatMemberIndicator: FC<Props> = ({ hasUnreadMessages, lastMessageIsFrom, classes }) => {
  if (hasUnreadMessages) {
    return (
      <div
        className={`rounded-full h-3 w-3 mr-3 ${classes.unreadIndicator}`}
        data-testid={ChatMemberIndicatorTestID.UnreadMessageIndicator}
      />
    );
  }

  if (lastMessageIsFrom === 'provider') {
    return (
      <ReplyArrow
        className="fill-current text-gray-400 h-3 w-3 mr-3"
        data-testid={ChatMemberIndicatorTestID.NeedsReplyIndicator}
      />
    );
  }

  return (
    <div
      className="bg-transparent rounded-full h-3 w-3 mr-3"
      data-testid={ChatMemberIndicatorTestID.EmptyIndicator}
    />
  );
};

export default withStyles(styles)(ChatMemberIndicator);
